// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.ellipsis-text[data-v-2d2bbdc2] {\n  min-width: 0;\n  white-space: nowrap !important;\n  /* 不换行 */\n  overflow: hidden !important;\n  /* 超出隐藏 */\n  text-overflow: ellipsis !important;\n  /* 超出部分显示为省略号 */\n}", ""]);
// Exports
module.exports = exports;
